import { PlusCircle } from 'react-feather';
import styled from '@emotion/styled';
import { primaryColorOrSentimentFallback } from '@trinity/chat-components/components/Theme';

type Props = {
  Icon?: React.ComponentType;
  css?: CSSOverrides;
  text?: string;
  onClick: () => void;
};

export const AddItem = ({ Icon = PlusCircle, css = {}, text = 'Add Widget', onClick }: Props) => {
  return (
    <StyledSlotContainer css={css} onClick={onClick}>
      <CenterContent>
        <AddButton>
          <Icon />
        </AddButton>
        <Text>{text}</Text>
      </CenterContent>
    </StyledSlotContainer>
  );
};

AddItem.displayName = 'Slot.AddItem';

const StyledSlotContainer = styled('div')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  alignItems: 'center',
  minHeight: '220px',
  height: '100%',
  width: '100%',
  borderRadius: '8px',
  backgroundColor: theme.palette.gray.light2,
  color: theme.palette.gray.dark1,
  stroke: theme.palette.gray.dark1,
  cursor: 'pointer',
  transition: 'all 0.2s ease-in-out',

  '&:hover': {
    color: primaryColorOrSentimentFallback(theme),
    stroke: primaryColorOrSentimentFallback(theme),
    // Apps without the white-label / sentiment palettes (the management app) use the MUI hover tint.
    backgroundColor: theme.palette.wl?.enabled
      ? theme.palette.btnPrimary.bg
      : (theme.palette.sentiment?.primary.light ?? theme.palette.action.hover),
  },
}));

const CenterContent = styled('div')({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
});

const AddButton = styled('button')(({ theme }) => ({
  background: 'none',
  border: 'none',
  color: 'inherit',
  padding: 0,
  display: 'flex',
  alignItems: 'center',
  cursor: 'inherit',
}));

const Text = styled('span')(({ theme }) => ({
  fontSize: '14px',
  fontFamily: 'var(--font-family)',
  marginTop: '4px',
}));
